import { ThemeProvider } from '@emotion/react'
import {
  Select,
  OutlinedInput,
  Box,
  MenuItem,
  Checkbox,
  FormHelperText,
  Typography
} from '@mui/material'
import { useAppSelector } from '~/app/hooks'
import { currentTheme, isDarkTheme } from '~/redux/features'
import { createCustomizedTheme, MenuProps } from '.'
import { StatusChip } from '../EFChip'
import { EFTypography } from '../EFTypography'
import classNames from 'classnames/bind'
import styles from './EFSelect.module.scss'
import { EFSelectMultipleProps } from './EFSelect.model'
import { EFInputLabel } from '../EFInputLabel'

const cx = classNames.bind(styles)
export function SelectMultipleCustom(props: EFSelectMultipleProps) {
  const { label, data, errorMessage, value } = props
  const theme = useAppSelector(currentTheme)
  const isDark = useAppSelector(isDarkTheme)
  return (
    <div className='custom-field'>
      {label && (
        <EFInputLabel
          name={props.name}
          label={label}
        />
      )}

      <ThemeProvider theme={createCustomizedTheme(isDark)}>
        <Select
          {...props}
          multiple
          className={cx('select-field', theme)}
          sx={{
            '& fieldset': {
              top: 0,
              '& legend': { display: 'none' }
            }
          }}
          input={
            <OutlinedInput
              id='select-multiple-chip'
              label='Chip'
            />
          }
          displayEmpty
          renderValue={(selected: any) => {
            if (!selected.length && props.placeholder) {
              return <Typography color='gray'>{props.placeholder}</Typography>
            }
            return (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value: any) => {
                  const displayName =
                    data.find(nameObj => nameObj.name === value)?.customText ?? value
                  return (
                    <StatusChip
                      className={cx('select-chip', theme)}
                      key={value}
                      label={
                        <EFTypography fontSize='var(--fs-sm)'>{displayName}</EFTypography>
                      }
                    />
                  )
                })}
              </Box>
            )
          }}
          labelId={props.name}
          id={props.name}
          MenuProps={MenuProps}
        >
          {data.map(item => (
            <MenuItem
              className={cx('menu-select-item', theme)}
              sx={{ paddingY: 0 }}
              key={item.value}
              value={item.name}
            >
              <Checkbox
                size='small'
                style={{ color: 'var(--primary-bg)' }}
                checked={value && value.indexOf(item.name) > -1}
              />
              {item.customText ?? item.name}
            </MenuItem>
          ))}
        </Select>
        {errorMessage && (
          <FormHelperText sx={{ color: 'red !important' }}>{errorMessage}</FormHelperText>
        )}
      </ThemeProvider>
    </div>
  )
}
